module.exports = __webpack_public_path__ + "img/404.c6b1358d.svg";